import aiAutomationSubpagesMeta from "@/data/ai-automation-subpages-meta.json";
import aiVisibilitySubpagesMeta from "@/data/ai-visibility-subpages-meta.json";
import leadGenSubpagesMeta from "@/data/lead-gen-subpages-meta.json";
import semSubpagesMeta from "@/data/sem-subpages-meta.json";
import seoSubpagesMeta from "@/data/seo-subpages-meta.json";
import webDesignSubpagesMeta from "@/data/web-design-subpages-meta.json";

type ServiceSubpageMetaEntry = {
  published: boolean;
  sitemapPath?: string;
};

const seoMeta = seoSubpagesMeta as Record<string, ServiceSubpageMetaEntry>;
const webDesignMeta = webDesignSubpagesMeta as Record<string, ServiceSubpageMetaEntry>;
const semMeta = semSubpagesMeta as Record<string, ServiceSubpageMetaEntry>;
const aiAutomationMeta = aiAutomationSubpagesMeta as Record<
  string,
  ServiceSubpageMetaEntry
>;
const aiVisibilityMeta = aiVisibilitySubpagesMeta as Record<
  string,
  ServiceSubpageMetaEntry
>;
const leadGenMeta = leadGenSubpagesMeta as Record<string, ServiceSubpageMetaEntry>;

const META_BY_SERVICE_TAG: Record<
  string,
  Record<string, ServiceSubpageMetaEntry>
> = {
  seo: seoMeta,
  "web-design": webDesignMeta,
  sem: semMeta,
  "ai-automation": aiAutomationMeta,
  "ai-visibility": aiVisibilityMeta,
  "lead-gen": leadGenMeta,
};

/**
 * Publish flag for a service mega-menu sub-page (`columns.<tag>.links[].key`).
 * Per-service sidecars in `src/data/*-subpages-meta.json`; unknown tags default to unpublished.
 */
export function isServiceSubpagePublished(serviceTag: string, subKey: string): boolean {
  const meta = META_BY_SERVICE_TAG[serviceTag];
  if (!meta) {
    return false;
  }
  return meta[subKey]?.published ?? false;
}
